module.exports = __webpack_public_path__ + "2189dd9e56b2024e338e867a3817cc09.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/broom.png
// module id = 2987
// module chunks = 0